import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { EnhancedTable, ConfigContext } from '../m34n-ui/src/lib';
import { useContext } from 'react';
import { TableCell } from '@mui/material';

export default function OrderGrid() {
    const gridRef = useRef();
    const navigate = useNavigate();
    const { config } = useContext(ConfigContext);

    const headCells = [
        { id: '_id', numeric: false, disablePadding: true, label: 'ID' },
        { id: 'firstName', numeric: false, disablePadding: true, label: 'First Name' },
        { id: 'lastName', numeric: false, disablePadding: true, label: 'Last Name' },
        { id: 'email', numeric: false, disablePadding: true, label: 'Email' },
        { id: 'productName', numeric: false, disablePadding: true, label: 'Product' },
        {
            id: 'createdAt', numeric: false, disablePadding: true, label: 'Created At',
            render: ({ rowData }) => {
                return (<TableCell>{new Date(rowData.createdAt).toLocaleString()}</TableCell>)
            }
        },
        {
            id: 'totalPrice', numeric: false, disablePadding: true, label: 'Total Price',
            render: ({ rowData }) => {
                return (<TableCell>${rowData.totalPrice}</TableCell>)
            }
        },
        {
            id: 'stripeStatus', numeric: false, disablePadding: true, label: 'Payment Status',
            render: ({ rowData }) => {
                return (<TableCell>{rowData?.payment?.payment_status || 'pending'}</TableCell>)
            }
        },
        {
            id: 'printStatus', numeric: false, disablePadding: true, label: 'Print Status',
            render: ({ rowData }) => {
                return (<TableCell>{rowData?.printJob?.status?.name || 'pending'}</TableCell>)
            }
        },
    ];

    const filterList = [
        { id: '_id', dataType: 'string', label: 'Order ID', defaultValue: '' },
        { id: 'firstName', dataType: 'string', label: 'First Name', defaultValue: '' },
        { id: 'lastName', dataType: 'string', label: 'Last Name', defaultValue: '' },
        { id: 'email', dataType: 'string', label: 'Email', defaultValue: '' },
        { id: 'productName', dataType: 'string', label: 'Product', defaultValue: '' },
        { id: 'createdAt', dataType: 'date', label: 'Created At', defaultValue: '' },
        { id: 'stripeStatus', dataType: 'string', label: 'Payment Status', defaultValue: '' },
        { id: 'printStatus', dataType: 'string', label: 'Print Status', defaultValue: '' }
    ];

    return (
        <div>
            <EnhancedTable
                ref={gridRef}
                tableName="Orders"
                searchEndpont={`${config.uri.base}/order`}
                actionRowClick={({ rowData }) => navigate(`/admin/order/${rowData._id}`)}
                actionDelete={async () => {
                    location.reload();
                }}
                headCells={headCells}
                filterList={filterList}
                pageSize={10}
            />
        </div>
    );
}
